import { Record } from "immutable";

const DropdownOptionRecord = Record({
  id: null,
  value: "",
  label: ""
});

export default DropdownOptionRecord;
